import { Link } from "react-router-dom";

const HERO_IMAGE_SRC = `${process.env.PUBLIC_URL || ""}/images/storm-king-art.jpg`;

export default function HomePage() {
  return (
    <main className="selection:bg-primary-container selection:text-on-primary">
      {/* Hero Section: The Curated Exhibition */}
      <section className="relative min-h-screen overflow-hidden px-6 pt-32 md:px-20 md:pt-40">
        <div className="absolute top-0 right-0 -z-10 h-2/3 w-2/3 translate-x-1/4 -translate-y-20 bg-secondary-fixed-dim" />
        <div className="relative grid grid-cols-1 items-start gap-8 md:grid-cols-12">
          <div className="flex flex-col gap-12 md:col-span-8">
            <div className="relative">
              <h1 className="mb-4 font-headline text-7xl uppercase leading-none tracking-tighter text-primary-container md:text-[10rem]">
                SOFIA &amp;
                <br />
                JASON
              </h1>
            </div>
            <div className="flex flex-col items-start gap-8 md:flex-row md:items-end">
              <div className="flex flex-col bg-primary px-8 py-6 md:px-12 md:py-8">
                <span className="mb-2 font-headline text-4xl text-on-primary">
                  JUNE
                </span>
                <span className="font-headline text-7xl leading-none text-on-primary">
                  2026
                </span>
              </div>
              <div className="max-w-sm">
                <p className="font-body text-lg leading-relaxed text-inverse-surface">
                  <strong className="font-bold">
                    An immersive exhibition of the heart.
                  </strong>{" "}
                  Amid the monumental landscapes of Storm King, join us for a
                  summer soirée celebrating the union of Sofia Toohey and Jason
                  Liao.
                </p>
              </div>
            </div>
          </div>
          <div className="relative mt-12 md:col-span-4 md:mt-48">
            <div className="absolute -left-10 -top-10 -z-10 h-40 w-40 bg-tertiary-fixed-dim" />
            <img
              src={HERO_IMAGE_SRC}
              alt="Monumental steel sculpture at Storm King Art Center, Hudson Valley landscape"
              className="aspect-[2/3] w-full object-cover object-[12%_center] shadow-[40px_40px_0px_#BDDEFE] grayscale contrast-[1.06]"
            />
          </div>
        </div>
      </section>

      {/* Program Block: Schedule */}
      <section className="px-6 py-32 md:px-20">
        <div className="flex flex-col gap-0 md:flex-row">
          <div className="relative w-full bg-secondary-fixed-dim p-12 md:w-3/4 md:p-24">
            <h2 className="mb-12 font-headline text-5xl uppercase tracking-tighter text-on-secondary-container md:text-8xl">
              The Program
            </h2>
            <div className="space-y-16">
              <div className="flex flex-col items-baseline gap-6 md:flex-row md:gap-24">
                <div className="flex flex-col gap-2">
                  <span className="font-headline text-2xl uppercase tracking-tight text-primary-container md:text-3xl">
                    June 12th, 2026 / 07:00 PM
                  </span>
                  <div>
                    <h3 className="mb-1 font-label text-2xl font-bold uppercase tracking-widest text-on-secondary-container">
                      Pillow &amp; Oats Brewery
                    </h3>
                    <p className="font-body text-sm uppercase tracking-widest text-on-secondary-container/70">
                      Welcome Party in Beacon
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex flex-col items-baseline gap-6 md:flex-row md:gap-24">
                <div className="flex flex-col gap-2">
                  <span className="font-headline text-2xl uppercase tracking-tight text-primary-container md:text-3xl">
                    June 13th, 2026 / 04:00 PM
                  </span>
                  <div>
                    <h3 className="mb-1 font-label text-2xl font-bold uppercase tracking-widest text-on-secondary-container">
                      Storm King Art Center
                    </h3>
                    <p className="font-body text-sm uppercase tracking-widest text-on-secondary-container/70">
                      Ceremony and Celebration
                    </p>
                  </div>
                </div>
              </div>
              <div className="pt-12">
                <Link
                  to="/details#rsvp"
                  className="inline-block bg-primary px-12 py-5 font-sans text-xs font-bold uppercase tracking-[0.2em] text-on-primary transition-all hover:bg-primary-container"
                >
                  Details &amp; RSVP
                </Link>
              </div>
            </div>
            <div className="absolute bottom-12 origin-bottom-right -right-12 rotate-90 md:bottom-24 md:-right-24">
              <span className="whitespace-nowrap font-headline text-8xl text-primary/10 md:text-[12rem]">
                06.13.26
              </span>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
